import {
    Autocomplete,
    type AutocompleteProps,
    type AutocompleteRenderInputParams,
    FormControl,
    FormLabel,
    TextField
} from '@mui/material';
import {type SyntheticEvent, useState} from 'react';
import {apiSearchOrganizationAll, type OrganizationPreviewDto} from "@/modules/exam-applications/shared";

type Props = {
    onChange: (value: OrganizationPreviewDto | null) => void;
    message?: string;
    defaultId?: number | null
    label?: string
} & Omit<AutocompleteProps<OrganizationPreviewDto, false, boolean, false>, 'options' | 'onChange' | 'renderInput'>

export function OrganizationAllAutocomplete({onChange, message, label, ...props}: Props) {
    const [q, setQ] = useState('');
    const [value, setValue] = useState<OrganizationPreviewDto | null>(null);
    const {data, isLoading} = apiSearchOrganizationAll({
        count: 50,
        offset: 0,
        q: value?.title === q ? '' : q
    });

    const renderInput = (params: AutocompleteRenderInputParams) => {
        return (
            <FormControl
                sx={{
                    gap:1
                }}
                fullWidth
            >
                {label && (
                    <FormLabel>
                        {label}
                    </FormLabel>
                )}
                <TextField
                    {...params}
                    placeholder="СЦОН"
                    error={!!message}
                    helperText={message}
                />
            </FormControl>
        );
    };

    const handleChange = (_: SyntheticEvent, newValue: OrganizationPreviewDto | null) => {
        setValue(newValue);
        onChange(newValue);
    };

    return (
        <>
            <Autocomplete
                value={value}
                onChange={handleChange}
                renderInput={renderInput}
                options={data?.items ?? []}
                getOptionLabel={(option) => option.title}
                isOptionEqualToValue={(o, v) => o.id === v.id}
                inputValue={q}
                onInputChange={(_, value) => setQ(value)}
                loading={isLoading}
                {...props}
            />
        </>
    );
}
